module.exports = __webpack_public_path__ + "img/hydroflux_lightmode_interface.7759ae89.png";